import { ProcedureTypeService as OvermapProcedureTypeService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProcedureTypeService extends OvermapProcedureTypeService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
